import { makeAssistantToolUI } from '@assistant-ui/react';

import { EntityDetailTool } from './entity-detail-tool';
import { KnowledgeTool } from './knowledge-tool';
import { ListResultTool } from './list-result-tool';
import { MutationResultTool } from './mutation-result-tool';

/**
 * Maps tool names to their render components using makeAssistantToolUI.
 * Each entry creates a React component that registers the tool UI via
 * useAssistantToolUI hook internally — renders null, no DOM output.
 */
const toolUIs: { toolName: string; Component: ReturnType<typeof makeAssistantToolUI> }[] = [
  // List tools — tabular display
  ...[
    'listBuildings',
    'listItems',
    'listSystems',
    'listTasks',
    'listProjects',
    'listTemplates',
    'listComments',
    'listPowerTypes',
  ].map((toolName) => ({
    toolName,
    Component: makeAssistantToolUI({ toolName, render: ListResultTool }),
  })),
  // Get tools — detail card display
  ...[
    'getBuilding',
    'getItem',
    'getSystem',
    'getTask',
    'getProject',
    'getTemplate',
    'getSettings',
  ].map((toolName) => ({
    toolName,
    Component: makeAssistantToolUI({ toolName, render: EntityDetailTool }),
  })),
  // Mutation tools — success/error chip display
  ...[
    'createItem',
    'updateItem',
    'createBuilding',
    'updateBuilding',
    'createSystem',
    'updateSystem',
    'createTask',
    'updateTask',
    'createProject',
    'updateProject',
    'createTemplate',
  ].map((toolName) => ({
    toolName,
    Component: makeAssistantToolUI({ toolName, render: MutationResultTool }),
  })),
  // Knowledge tools — markdown block with book icon
  {
    toolName: 'lookupConstruction',
    Component: makeAssistantToolUI({ toolName: 'lookupConstruction', render: KnowledgeTool }),
  },
];

/**
 * Render this component inside AssistantRuntimeProvider / ThreadPrimitive.Root
 * to register all tool UIs with the runtime. Renders null.
 */
export const ToolRegistration = () => {
  return toolUIs.map(({ toolName, Component }) => <Component key={toolName} />);
};
